import React from 'react';
import { UiWidget as Ui } from '../';
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from 'react-i18next';

interface itemProp {
  title?: string;
  onClick?: () => void;
  icon?: JSX.Element;
  rightIcon?: JSX.Element;
  hasSubMenu?: boolean;
  customSubMenuComponent?: JSX.Element;
}

interface dropdownProps {
  showMenu?: boolean;
  setShowMenuOptions?: (data: boolean) => void;
  setIsEditAdminPopupOpen?: (data: boolean) => void;
  handleToggleCalendar?: () => void;
  dateRange?: string;
  customDropdownItems?: itemProp[];
}

const WidgetCustomDropdown = ({
  showMenu,
  setShowMenuOptions,
  customDropdownItems
}: dropdownProps): JSX.Element => {
  const { t } = useTranslation(['mh']);

  if (!showMenu) return <></>;

  return (
    <>
      {showMenu && (
        <div className='dropdown-wrapper'>
          <Ui.MenuContainer>
            {customDropdownItems &&
              customDropdownItems.map((data) => {
                return (
                  <>
                  <Ui.MenuItem
                    key={uuidv4()}
                    onClick={() => {
                      data.onClick && data.onClick()
                      !(data.hasSubMenu) && setShowMenuOptions ? setShowMenuOptions(!showMenu) : null;
                    }}
                  >
                    <Ui.MenuItemIcon>{data.icon}</Ui.MenuItemIcon>
                    <Ui.MenuItemText>{data.title}</Ui.MenuItemText>
                    {data.rightIcon && (
                      <Ui.MenuItemRightIcon>{data.rightIcon}</Ui.MenuItemRightIcon>
                    )}
                  </Ui.MenuItem>
                  {/* Render custom submenu component if applicable */}
                  {data.customSubMenuComponent ? data.customSubMenuComponent : null}
                </>
                );
              })}
          </Ui.MenuContainer>
        </div>
      )}
    </>
  );
};

export default WidgetCustomDropdown;
